import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/searchPage/actionTypes';
import { load } from './utils';

export default function* listenSearch() {
  yield takeEvery(actionTypes.LOAD, load);
}
